import { render } from "./ProductOverview.vue?vue&type=template&id=3cdd4dd2&ts=true"
import script from "./ProductOverview.vue?vue&type=script&lang=ts"
export * from "./ProductOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__